import { differenceInSeconds, parseISO, addMinutes } from 'date-fns';
import * as Sentry from '@sentry/browser';
import View from './view';
import Analytics from './analytics';
import Verify from './verify';
import Logger from '../utils/logger';

const ONE_DAY = 60 * 60 * 24;
const ONE_HOUR = 60 * 60;
const ONE_MINUTE = 60;
let timerInterval;

let DEADLINE;
try {
  /**
   * Se sono in dev setto lo start_event ad un minuto dalla data di accesso
   * utente e lo switchoff a 12 minuti dalla data di accesso
   */
  DEADLINE = process.env.START_DATE
    ? parseISO(process.env.START_DATE)
    : addMinutes(new Date(), 1);
} catch (err) {
  Sentry.captureException(err);
  Logger('error', err);
  // Se fallisce setto io la deadline
  DEADLINE = new Date(2022, 5, 15, 9, 0, 0);
}

if (process.env.STAGE === 'dev') {
  window.setDeadline = (newDate) => {
    console.warn(`Aggiornamento deadline alle ${newDate.toISOString()}`);
    DEADLINE = newDate;
  };
}

const startTimer = (userId, endEvent) => {
  try {
    const clockDiv = document.querySelector('.tf22-wait-clock');
    const daysDiv = clockDiv.querySelector('.clock--days');
    const hoursDiv = clockDiv.querySelector('.clock--hours');
    const minutesDiv = clockDiv.querySelector('.clock--minutes');
    const secondsDiv = clockDiv.querySelector('.clock--seconds');
    // Setup del currentTime
    const currentTime = new Date().getTime();

    // Prendo la differenza in secondi tra le 2 date
    const diffInSeconds = differenceInSeconds(DEADLINE, currentTime);

    if (diffInSeconds <= 0) {
      // faccio il clearInterval e lo switch delle risorse
      daysDiv.innerHTML = '0';
      hoursDiv.innerHTML = '0';
      minutesDiv.innerHTML = '0';
      secondsDiv.innerHTML = '0';
      clearInterval(timerInterval);
      View.hideCountdown();
      View.showDiretta();
      if (process.env.MANUAL_CHECKS_ENABLED === 'true') {
        Verify.init(userId);
      }
      window.analyticsJob = Analytics.init(userId, endEvent);
    }
    const days = Math.floor(diffInSeconds / ONE_DAY);
    const hours = Math.floor((diffInSeconds - days * ONE_DAY) / ONE_HOUR);
    const minutes = Math.floor(
      (diffInSeconds - days * ONE_DAY - hours * ONE_HOUR) / ONE_MINUTE,
    );
    const seconds =
      diffInSeconds - days * ONE_DAY - hours * ONE_HOUR - minutes * ONE_MINUTE;

    daysDiv.innerHTML = days <= 9 ? `0${days}` : days;
    hoursDiv.innerHTML = hours <= 9 ? `0${hours}` : hours;
    minutesDiv.innerHTML = minutes <= 9 ? `0${minutes}` : minutes;
    secondsDiv.innerHTML = seconds <= 9 ? `0${seconds}` : seconds;
  } catch {
    // Catch per gestire eventuali errori durante il countdown
    clearInterval(timerInterval);
    if (!differenceInSeconds(DEADLINE, new Date().getTime()) > 0) {
      // Se il tempo non è scaduto, provo a rieseguire il countdown
      init(userId, endEvent);
      return;
    }
    // Se il tempo è scaduto e l'analytics non è partito, lo avvio
    if (!window.analyticsJob) {
      window.analyticsJob = Analytics.init(userId, endEvent);
    }
  }
};

const init = (userId, endEvent) => {
  timerInterval = setInterval(startTimer, 1000, userId, endEvent);
};

export default { init };
